module.exports = __webpack_public_path__ + "img/record.e5610f93.svg";